import { FC, ReactNode } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import LoadingSvg from "@/assets/svg/LoadingSvg";
import theme from "@/theme";

interface CustomLoaderProps {
  loading?: boolean;
  children?: ReactNode;
  size?: number;
  isModal?: boolean;
  sx?: SxProps<Theme>;
  color?: string;
}

const CustomLoader: FC<CustomLoaderProps> = ({
  loading = true,
  children,
  size = 42,
  isModal = false,
  sx,
  color = theme.palette.custom.mainBlue,
}) => {
  if (!loading) return <>{children}</>;

  return (
    <Box
      sx={{
        position: isModal ? "fixed" : "relative",
        top: isModal ? 0 : undefined,
        left: isModal ? 0 : undefined,
        width: isModal ? "100%" : "auto",
        height: isModal ? "100%" : "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: isModal ? 2 : 1,
        ...(isModal && {
          "& > .loader-content": {
            filter: "blur(4px)",
            pointerEvents: "none",
            userSelect: "none",
          },
        }),
        ...((sx as object) || {}),
      }}
    >
      <LoadingSvg width={size} height={size} color={color} />
    </Box>
  );
};

export default CustomLoader;
